import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography, CircularProgress, Stack, alpha, useTheme } from '@mui/material'

const StatusOverlay = ({ loading, error, empty, variableName, t_ }) => {
  const theme = useTheme()

  if (!loading && !error && !empty) return null

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 5,
        backgroundColor: alpha(theme.palette.background.paper, 0.4),
        backdropFilter: 'blur(4px)'
      }}
    >
      {loading
        ? (
          <>
            <CircularProgress size={40} thickness={4} />
            <Typography variant='caption' color='text.secondary' fontWeight={500}>
              {t_ ? t_('Loading data...') : 'Loading data...'}
            </Typography>
          </>
          )
        : error
          ? (
            <Typography color='error' variant='caption' fontWeight={600}>
              {t_ ? t_('Error loading data') : 'Error loading data'}
            </Typography>
            )
          : !variableName
              ? (
                <Stack alignItems='center' spacing={1} sx={{ opacity: 0.7 }}>
                  <Typography variant='body2' color='text.secondary' fontWeight={500}>
                    {t_ ? t_('Select a variable') : 'Select a variable'}
                  </Typography>
                  <Typography variant='caption' color='text.secondary' align='center'>
                    {t_ ? t_('Configure the widget to visualize data') : 'Configure the widget to visualize data'}
                  </Typography>
                </Stack>
                )
              : (
                <Stack alignItems='center' spacing={1} sx={{ opacity: 0.7 }}>
                  <Typography variant='body2' color='text.secondary' fontWeight={500}>
                    {t_ ? t_('No data available') : 'No data available'}
                  </Typography>
                  <Typography variant='caption' color='text.secondary'>
                    {t_ ? t_('Try with another date range') : 'Try with another date range'}
                  </Typography>
                </Stack>
                )}
    </Box>
  )
}

StatusOverlay.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.object,
  empty: PropTypes.bool,
  variableName: PropTypes.string,
  t_: PropTypes.func
}

export default StatusOverlay
